'use client';

import { Button } from '~/components/Button';
import { CopyIcon } from './CopyIcon';
import { useCopyToClipboard } from './useCopyToClipboard';

type CopyCodeButtonProps = Readonly<{
  code: string;
}>;

export const CopyCodeButton = ({ code }: CopyCodeButtonProps) => {
  const { status, label, copy } = useCopyToClipboard();

  return (
    <Button variant="icon" isTransparent ariaLabel={label} onPress={() => copy(code)}>
      <CopyIcon status={status} />
    </Button>
  );
};
